<template>
	<section>
		<router-link :to="{name: status == 'VALIDATED' ? 'SuperAdminPendingQcmPackages': 'SuperAdminAllQcmPackages'}"  class="submit dark">Voir les questions <span v-if="status == 'VALIDATED'"> en attente</span> <span v-else>validés</span></router-link>
		<h1>Liste package QCM <span v-if="status == 'VALIDATED'"> validés</span> <span v-else>en attente</span></h1>
		<pagination-component
			v-if="pages > 1"
			:totalPages="pages"
			:perPage="20"
			:currentPage="currentPage"
			@pageChanged="getNewQuestions"
		/>
		<FilterWrapper  @updateFilter="updateFilter" :show-search="false" :show-filter="false" />
		
		<table style="width: 100%;">
			<tr>
				<th></th>
				<th>Titre</th>
				<th>Auteur</th>
				<th>Voir</th>
				<th>Modifier</th>
				<th>Supprimer</th>
				<th>Status</th>
			</tr>
			<tr v-for="(content, index) in packages" :key="index">
				<td>{{ index + 1 }}</td>
				<td>{{ content.title }}</td>
				<td>{{ content.teacher }}</td>
				
				<td>
					<button class="see" @click="showPopUpPreview(content)">
						<img src="/img/super-admin/blue-eye.svg" alt="" />
					</button>
				</td>
				<td>
					<router-link :to="{name: 'SuperAdminEditQcmPackage', params: {id: content.id}}" class="edit">
						Modifier
					</router-link>
				</td>
				<td>
					<button
						class="delete"
						v-if="checkIfSuperAdminAndValidatedStatus(content.status)"
						@click="deleteQuestion(content.id)"
					>
						<img src="/img/super-admin/blue-trash.svg" alt="" />
					</button>
				</td>
				<td> <span :style="getStyleColor(content.status)">{{  translate(content.status)  }}</span></td>
				
			</tr>
			
		</table>
		<Teleport to="body">
			<PopUpPreviewQcmPackage v-if="isPopUpPreviewVisible" :content="selectedPackage" @close="isPopUpPreviewVisible = !isPopUpPreviewVisible" @updateQcmPackage="removeQuestion" />
		</Teleport>
	</section>
</template>
<script>
import PaginationComponent from '../../Utils/PaginationComponent.vue'
import { filteredQCMQuestionPackageService,deleteQCMQuestionPackageService } from '../../../services/qcmQuestionPackagesServices'
import PopUpPreviewQcmPackage from '../../PopUp/QCMPackage/PopUpPreviewQcmPackage.vue'
import FilterWrapper from '../../Admin/Search/FilterWrapper.vue'

export default {
	components: {
		PaginationComponent,
		PopUpPreviewQcmPackage,
		FilterWrapper
	},
	props: {
		status: {
			type: String,
			default: 'VALIDATED',
		}
	},
	data() {
		return {
			packages: [],
			currentPage: 0,
			pages: 0,
			filters: {
				level: '',
				teacher: '',
				chapter: '',
				status: '',
				text: ''
			},
			isPopUpPreviewVisible: false,
			selectedPackage: null,
		}
	},
	methods: {
		removeQuestion(id) {
			this.packages = this.packages.filter((question) => question.id !== id)
		},
		showPopUpPreview(question){
			this.isPopUpPreviewVisible = true
			this.selectedPackage = question
		},
		translate(status) {
			switch (status) {
				case 'VALIDATED':
					return 'Approuvé'
				case 'REFUSED':
					return 'Refusé'
				case 'PENDING':
					return 'En attente'
			}
		},
		getStyleColor(status) {
			switch (status) {
				case 'VALIDATED':
					return `color: #17A81C`
				case 'PENDING':
					return `color: #fff;background-color:#F0961A;`
				case 'REFUSED':
					return `color: #DE1D1D`
				case 'PRIVATE':
					return `color: #000`
			}
		},
		async allQcmQuestions() {
			this.filter = `?chapter=${this.filters.chapter}&level=${this.filters.level}&teacher=${this.filters.teacher}&offset=${this.currentPage * 20}`
			const res  = await filteredQCMQuestionPackageService(this.filter, this.status)
			this.packages = res.results
			const total = res.count
			this.pages = Math.ceil(total / 10)

		},
		checkIfSuperAdminAndValidatedStatus(status) {

			if (status == 'VALIDATED') {
				if (this.$store.state.user.role == 'SUPER_ADMIN')
					return true
				return false
			}
			return true
		},
		async deleteQuestion(id) {
			if (confirm("Do you really want to delete?")) {
				await deleteQCMQuestionPackageService(id)
				this.getNewQuestions()
			}
		},
		updateFilter(data) {
			this.filters.level = data.level
			this.filters.subject = data.subject
			this.filters.chapter = data.chapter
			this.getNewQuestions()
		},
		async getNewQuestions(e){
			this.currentPage = e || 1
			const chapter = this.filters.chapter ? `chapter=${this.filters.chapter}` : 'chapter='
			const level = this.filters.level ? `&level=${this.filters.level}` : '&level='
			const teacher = this.filters.teacher ? `&teacher=${this.filters.teacher}` : '&teacher='
			const subject = this.filters.subject ? `&subject=${this.filters.subject}` : '&subject='
			this.filter = `?${chapter}${level}${teacher}${subject}&page=${this.currentPage}`
			
			const res = await filteredQCMQuestionPackageService(this.filter,this.status)
			this.packages = res.results
			const total = res.count
			this.pages = Math.ceil(total / 10)
		}
	},
	
}
</script>
